// Ubicaciones en vivo recibidas por WebSocket. Ver CLAUDE.md §7.
import { create } from 'zustand'

export interface LiveLocation {
  user_id: string
  name: string
  lat: number
  lng: number
  accuracy: number | null
  timestamp: string
}

interface LocationState {
  locations: Record<string, LiveLocation> // por user_id
  upsert: (loc: LiveLocation) => void
  remove: (userId: string) => void
  prune: (maxAgeMs: number) => void
  clear: () => void
}

export const useLocationStore = create<LocationState>((set) => ({
  locations: {},
  upsert: (loc) => set((s) => ({ locations: { ...s.locations, [loc.user_id]: loc } })),
  remove: (userId) =>
    set((s) => {
      const rest = { ...s.locations }
      delete rest[userId]
      return { locations: rest }
    }),
  prune: (maxAgeMs) =>
    set((s) => {
      const now = Date.now()
      const kept = Object.fromEntries(
        Object.entries(s.locations).filter(([, l]) => now - Date.parse(l.timestamp) < maxAgeMs),
      )
      return { locations: kept }
    }),
  clear: () => set({ locations: {} }),
}))
